import { Box } from "@mui/material";
import { alpha, PaletteColor } from "@mui/material/styles";
import { ReactNode } from "react";
import { useTheme } from "../../context/ThemeContext";
import { Sx } from "./dataAtoms/shared";

/** How strongly a badge is washed with the colour of its tone. */
const TINT_ALPHA = 0.12;

/**
 * A short status word on a wash of its colour, with the text in the colour's
 * dark shade. Without a tone it is neutral: a state that is neither good nor
 * bad, such as nothing having happened yet.
 */
export const TonalBadge = ({
  tone,
  title,
  children,
  sx,
}: {
  tone?: PaletteColor;
  title?: string;
  children: ReactNode;
  sx?: Sx;
}) => {
  const { theme } = useTheme();

  return (
    <Box
      component="span"
      title={title}
      sx={[
        {
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          px: 1,
          py: 0.25,
          borderRadius: 1.25,
          typography: "caption",
          fontWeight: 700,
          whiteSpace: "nowrap",
          bgcolor: tone
            ? alpha(tone.main, TINT_ALPHA)
            : theme.palette.action.hover,
          color: tone ? tone.dark : "text.secondary",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
};
